import React, { useEffect, useState } from 'react';
import '../styles/Navbar.scss';
import logo from '../assets/lonavalley-logo.png';

export default function Navbar() {
    const [sticky, setSticky] = useState(false);
    const [open, setOpen] = useState(false);


    useEffect(() => {
        const onScroll = () => setSticky(window.scrollY > 60);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    const scrollTo = (id) => {
        setOpen(false);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };


    return (
        <header className={`site-nav ${sticky ? 'sticky' : ''}`}>
            <div className="nav-inner">
                <div className="brand" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    <img src={logo} alt="Lonavalley logo" />
                    <span className="brand-text">Lonavalley @Lonavala Annex</span>
                </div>


                <nav className={`links ${open ? 'open' : ''}`} aria-label="Main Navigation">
                    <button onClick={() => scrollTo('highlights')}>Highlights</button>
                    <button onClick={() => scrollTo('location')}>Location</button>
                    <button onClick={() => scrollTo('amenities')}>Amenities</button>
                    <button onClick={() => scrollTo('gallery')}>Gallery</button>
                    <button onClick={() => scrollTo('faq')}>FAQ?</button>
                    <button onClick={() => scrollTo('pricing')}>Pricing</button>
                    <button onClick={() => scrollTo('contact')}>Contact</button>
                    <a className="cta" href="#contact">Get Brochure</a>
                </nav>


                <button className={`hamburger ${open ? 'active' : ''}`} onClick={() => setOpen(v => !v)} aria-label="Toggle menu">
                    <span />
                    <span />
                    <span />
                </button>
            </div>
        </header>
    );
}